<template>
	<div v-loading="dataLoading">
		<el-form v-if="formData" :model="formData" :rules="rules" ref="formData" label-position="top">
			<el-card header="基础信息" shadow="none">
				<el-row :gutter="30">
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item prop="thirdName" label="内容渠道名称:">
							<el-input placeholder="请输入内容渠道名称" v-model="formData.thirdName" size="medium" maxlength="30"
								show-word-limit></el-input>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item prop="channelKey" label="内容渠道Key:">
							<el-input placeholder="请输入内容渠道Key" v-model="formData.channelKey" size="medium"
								maxlength="30" show-word-limit></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="30">
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item prop="channelDomain" label="对接域名:">
							<el-input placeholder="请输入对接域名" v-model="formData.channelDomain" size="medium"></el-input>
							<small><span class="color-warning">结尾不需要加 /</span></small>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item prop="channelCode" label="渠道方分配的Code:">
							<el-input placeholder="请输入渠道方分配的Code" v-model="formData.channelCode" size="medium"
								maxlength="50" show-word-limit></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="30">
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item prop="source" label="秀动分配的Source:">
							<el-input placeholder="请输入秀动分配的Source" v-model="formData.source" size="medium"
								maxlength="50" show-word-limit></el-input>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item prop="token" label="秀动分配的Token:">
							<el-input  v-model="formData.token" size="medium" disabled></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="30">
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item prop="status" label="内容渠道状态:">
							<el-radio-group v-model="formData.status" size="medium">
								<el-radio :label="1">启用</el-radio>
								<el-radio :label="0">禁用</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item prop="orderPrefix" label="订单前缀:">
							<el-input placeholder="请输入订单前缀" v-model="formData.orderPrefix" size="medium"></el-input>
							<small><span
									class="color-warning">限制必须4个小写字母,能表达清楚含义<br>比如ycls,yc表示云仓,ls表示龙狮,也可以用别的字母,不能和库里现有重复</span></small>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="30">					
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item prop="privilege" label="可以访问的路径:">
							<el-input type="textarea" v-model="formData.privilege" placeholder="请填写可以访问的路径"
								size="medium" :maxlength="500" show-word-limit></el-input>
							<small><span class="color-warning">多个之间英文逗号区隔</span></small>
						</el-form-item>
					</el-col>
				</el-row>
			</el-card>
			<el-card header="演出默认信息(用于创建项目时初始化)" class="MT20" shadow="none">
				<el-row :gutter="30">
					<el-col :xs="24" :sm="12" :xl="8">						
						<el-form-item prop="startUserId" label="演出发起人">
						    <el-select 
						        v-model="formData.startUserId" 
						        filterable 
						        remote
						        placeholder="请输入演出发起人"
						        :remote-method="searchStartUser"
						        :loading="userLoading"
						        size="medium">
						        <el-option
						            v-for="item in startUserList"
						            :key="item.id"
						            :label="item.name"
						            :value="item.id">
						        </el-option>
						    </el-select>
						    
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item prop="principalId" label="项目负责人:">
						    <el-select 
						        v-model="formData.principalId" 
						        filterable 
						        remote
						        placeholder="请输入项目负责人"
						        :remote-method="searchPrincipal"
						        :loading="userLoading"
						        size="medium">
						        <el-option
						            v-for="item in principalList"
						            :key="item.id"
						            :label="item.name"
						            :value="item.id">
						        </el-option>
						    </el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="30">
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item prop="isShowCode" label="票夹展示票码逻辑:">
							<el-radio-group v-model="formData.isShowCode" size="medium">
								<el-radio :label="2">强制展示：票夹中的票直接看码</el-radio><br>
								<el-radio :label="1" class="MT10">有限展示：观演人才能看码</el-radio><br>
								<el-radio :label="0" class="MT10">强制关闭：仅提示用户携带身份证件入场</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item prop="contactsName" label="演出联系人:">
							<el-input placeholder="请输入演出联系人" v-model="formData.contactsName" size="medium"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="30">
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item prop="contactsTel" label="联系人手机号:">
							<el-input placeholder="请输入联系人手机号" v-model="formData.contactsTel" size="medium"></el-input>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item prop="contactsMail" label="联系人邮箱:">
							<el-input placeholder="请输入联系人邮箱" v-model="formData.contactsMail" size="medium"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="30">
					<el-col :xs="24" :xl="16">
						<el-form-item prop="serviceTemplateId">
							<p slot="label">
								购票须知: <template v-if="formData.id">（<span class="color-danger">红色模板为当前渠道专用模板，其模板内容只在当前渠道下展示，点击选项可以编辑模板内容</span>）
								<el-button type="primary" plain size="mini"
									@click="$refs.ActivitySyncTemplate.show('',formData.id)">创建专用模板</el-button></template>
							</p>
							<el-checkbox-group v-model="formData.serviceTemplateId" size="medium">
								<el-table :data="serviceTemplateList" border style="width: 100%" size="small"
									class="templateTable">
									<el-table-column label="一级分类" width="100px" prop="label"></el-table-column>
									<el-table-column label="二级分类" width="100px">
										<template slot-scope="{row} = scope">
											<ul>
												<li v-for="(item) in row.children" :key="item.value">{{item.label}}
													{{item.id}}</li>
											</ul>
										</template>
									</el-table-column>
									<el-table-column label="模板">
										<template slot-scope="{row} = scope">
											<ul class="secondUl">
												<li v-for="(item,index) in row.children" :key="index" class="textLeft">													
													<span v-for="item2 in item.children" :key="item2.id" class="MR20">
														<el-checkbox :label="item2.id.toString()">
															<span :class="{'color-danger': item2.bindIds}">{{item2.title}}
																[{{item2.id}}]</span>
														</el-checkbox>
														<el-popover width="400">
															<div v-html="item2.chineseContent"></div>
															<el-link slot="reference" type="info" :underline="false"
																style="vertical-align: baseline;"><span
																	class="el-icon-question"></span></el-link>
														</el-popover>
														<el-button type="text" size="small" icon="el-icon-edit"
															v-if="item2.bindIds"
															@click="$refs.ActivitySyncTemplate.show(item2.id,item2.bindIds)">
														</el-button>
													</span>
												</li>
											</ul>
										</template>
									</el-table-column>
								</el-table>
							</el-checkbox-group>
							
						</el-form-item>
					</el-col>
				</el-row>
			</el-card>
			<el-card header="结算默认信息" class="MT20" shadow="none">
				<el-row :gutter="30">
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item prop="serviceFee" label="秀动服务费比例:">							
							<el-input-number v-model="formData.serviceFee" controls-position="right" :min="0" :max="100" :precision="2" style="width: 95%;"></el-input-number> %		
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :xl="8">						
						<el-form-item prop="agentUserId" label="代理商:">
							<el-select v-model="formData.agentUserId" filterable remote :remote-method="searchAgent"
							:loading="userLoading" clearable >
								<el-option v-for="item in agentList" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="30" v-if="formData.agentUserId" >
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item prop="agentServiceFee" label="代理费占票提比例：">							
							<el-input-number v-model="formData.agentServiceFee" controls-position="right" :min="0" :max="100" :precision="2" style="width: 95%;"></el-input-number> %
							<small><span class="color-warning">注意:是占秀动票提的百分比,比如秀动票提为8%，下面填20%,实际为销售额的 8%*20%
									=1.6%</span></small>
						</el-form-item>
					</el-col>
				</el-row>
			</el-card>
		</el-form>
		<div class="MT20">
			<el-button @click="goBack">返回</el-button>
			<el-button v-if="$utils.have('/content/channel/manage/saveOrUpdate')" type="primary" @click="onSubmit"
				:loading="btnLoading">保存</el-button>
		</div>
		<activity-sync-template ref="ActivitySyncTemplate"  @onUpdate="getTemplate()" :activityId="id" v-if="formData && serviceTemplate" ></activity-sync-template>
	</div>
</template>
<script>
	import ActivitySyncTemplate from './components/activity-sync-template';
	import {fetchServiceTemplateType,fetchUser,fetchAgent} from '@/assets/js/commonApi';
	const defaultFormData = {
		thirdName: '',
		agentServiceFee: "",
		agentUserId: "",
		channelCode: "",
		channelDomain: "",
		channelKey: "",
		contactsMail: "",
		contactsName: "",
		contactsTel: "",
		id: '',
		isShowCode: 2,
		orderPrefix: "",
		principalId: '',
		privilege: "",
		serviceFee: undefined,
		serviceTemplateId: [],
		source: "",
		startUserId: '',
		status: 1,
		token: ''

	}
	export default {
		props: {
		    id: {
		        type: [Number, String],
		        default: ""
		    }
		},
		components:{ActivitySyncTemplate},
		data() {
			return {
				dataLoading: false,
				btnLoading: false,
				userLoading:false,
				user2Loading:false,
				formData: {
					...defaultFormData
				},
				serviceTemplateType: [],
				serviceTemplate: null,
				serviceTemplateList: [],
				agentList: [],
				principalList:[], //项目负责人集合(临时)
				startUserList:[], //演出发起人集合(临时)
				rules: {
					thirdName: [{
						required: true,
						message: "请输入内容渠道名称"
					}],
					channelKey: [{
						required: true,
						message: "请输入内容渠道Key"
					}],
					channelDomain: [{
						required: true,
						message: "请输入对接域名"
					}],
					channelCode: [{
						required: true,
						message: "请输入渠道方分配的Code"
					}],
					source: [{
						required: true,
						message: "请输入秀动分配的Source"
					}],
					startUserId: [{
						required: true,
						message: "请输入演出发起人"
					}],
					principalId: [{
						required: true,
						message: "请输入项目负责人"
					}],
					contactsTel:[{ validator: this.$utils.validatePhone }],
					contactsMail:[{ type: "email", message: "请输入正确的邮箱地址" }],
				},
			};
		},
		async created() {
			if (this.id) {
				this.getDetailData();				
			}
			this.serviceTemplateType = await fetchServiceTemplateType();
			this.getTemplate();			
		},
		
		methods: {
			//获取服务模板
			getTemplate() {
				this.serviceTemplateList = [];
				this.$request({
					url: "/content/channel/manage/getTemplate",
					params: {
						id:this.id ? this.id :''
					},
					method: "post",
				}).then(res => {
					const {
						state,
						result,
						msg
					} = res.data;
					if (state == 1 && result) {
						this.serviceTemplate = result
						var level1List = [{
							value: 1,
							label: '服务说明'
						}, {
							value: 2,
							label: '购票须知'
						}, {
							value: 3,
							label: '观演须知'
						}];
						var newLevel = [];
						for (let key1 in this.serviceTemplate) {
							//console.log("key1",key1);
							var level1 = JSON.parse(JSON.stringify(level1List.find(v => v.value == key1)));
							level1.children = []
							for (let key2 in this.serviceTemplate[key1]) {
								var level2 = JSON.parse(JSON.stringify(this.serviceTemplateType.find(v => v
									.value == key2)));

								level2.children = this.serviceTemplate[key1][key2]
								level1.children.push(level2)
							}
							newLevel.push(level1)
						}
						this.serviceTemplateList = newLevel
					} else {
						this.$message.error(msg && "获取购票须知失败");
					}
				})
			},
			// 项目负责人搜索
			async searchPrincipal(query){
			    if(query !== ""){
			        this.user2Loading = true;
			        const res = await this.$request({
			            url: '/adminUser/list',
			            method: 'POST',
			            params: {keyword:query}
			        }).finally(() => {
			            this.user2Loading = false;
			        });
			        
			        const { state, result } = res.data;
			        
			        if (state == 1 && result) {
			            this.principalList = result;
			        }
			    }    
			},
			// 搜索代理商
			async searchAgent(query){
				
				if(query !== ""){
					this.userLoading = true;
					const res = await fetchAgent(query)
					.finally(() => {
						this.userLoading = false;
					});
					
					const { state, result } = res.data;
					
					if (state == 1 && result) {
						this.agentList = result || [];
					}
				}
			},
			// 演出发起人搜索
			searchStartUser(query){
			    this.searchUser(query,-1,'startUserList');
			},
			// 搜索用户
			async searchUser(query,userType,obj){
			    if(query !== ""){
			        this.userLoading = true;
			        const res = await fetchUser({
			            queryValue:query,
			            userType:userType,
			        }).finally(() => {
			            this.userLoading = false;
			        });
			        
			        const { state, result } = res.data;
			        
			        if (state == 1 && result) {
			            this[obj] = result;
			        }
			    }
			},
			//获取详情
			getDetailData() {
				this.dataLoading = true;
				this.$request({
						url: "/content/channel/manage/detail",
						method: "POST",
						params: {
							id: this.id
						},
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1 && result) {
							this.formData = {
								...defaultFormData,
								...result,
								startUserId: result.startUser && result.startUser.id || '',
								principalId: result.principal && result.principal.id || '',
								agentUserId: result.agentUser && result.agentUser.id || '',								
								serviceTemplateId: result.serviceTemplateId && result.serviceTemplateId.split(',') || [],
							};
							this.startUserList = result.startUser ? [{ ...result.startUser, name: result.startUser.name }] : [];							
							this.principalList = result.principal ? [{ ...result.principal, name: result.principal.name }] : [];
							this.agentList = result.agentUser ? [{ ...result.agentUser, name: result.agentUser.name }] : [];
						} else {
							this.$message.error(msg || "请求失败");
						}
					})
					.catch(() => {
						this.$message.error("请求错误");
					})
					.finally(() => {
						this.dataLoading = false;
					});
			},
			onSubmit() {
				this.$refs["formData"].validate( async (valid) => {
				    if(valid){				       
				        this.btnLoading = true;
				        this.$request({
				            url: "/content/channel/manage/saveOrUpdate",
				            method: "POST",
				            data: {
				                ...this.formData,
								serviceTemplateId: this.formData.serviceTemplateId.toString()
				            },
				        })
				        .then((res) => {
				            const { state, msg } = res.data;
				            if ( state == 1 && this.formData.id ) {
				                this.$confirm('操作成功', '提示', {
				                	type: 'success',
				                	center: true,
				                	confirmButtonText:'返回列表',
				                	cancelButtonText:'留在当前页面',
				                	closeOnClickModal: false
				                }).then(() => {
				                	this.goBack();
				                }).catch(() => {
				                	this.getDetailData();
				                })        
				            }else if(  state == 1 && !this.formData.id ){
								this.goBack();
							} else {
				                this.$message.error(msg || "请求失败");
				            }
				        })
				        .catch(() => {
				            this.$message.error("请求错误");
				        })
				        .finally(() => {
				            this.btnLoading = false;
				        });
				    }else{
				        return false;
				    }
				})
			},
			//返回
			goBack() {
				if (this.redirect) {
					this.$router.push({
						path: this.redirect,
					});
				} else {
					this.$router.go(-1);
				}
			},
		}
	};
</script>
<style lang="scss" scoped>
	.serviceTemplateList {
		display: flex;
		flex-wrap: wrap;

		>span {
			margin: 5px 20px 5px 0;
		}
	}

	.pointer {
		cursor: pointer;
	}

	.secondUl {
		>li {
			// height: 40px;
			line-height: 40px;
			text-align: center;

			border-bottom: 1px solid #eee;

			&.textLeft {
				text-align: left;
				// padding-left: 20px;
			}

			&:last-child {
				border-bottom: none;
			}

			span {
				white-space: nowrap;
			}
		}
	}
</style>